import jwtDecode, { JwtPayload } from "jwt-decode";
import { Token } from "../Contenedores/Autenticador/ClasesOAuth";

function guardarToken(token: Token) {
  localStorage.setItem("token", JSON.stringify(token));
}

export function obtenerToken() {
  const token = localStorage.getItem("token") || "";
  let parsedToken = token ? JSON.parse(token) : null;
  return parsedToken;
}

export function obtenerAccessToken() {
  let token = obtenerToken();
  return token.access_token;
}

export function estaExpiradoElAccessToken() {
  try {
    const token = jwtDecode<JwtPayload>(obtenerAccessToken());
    return token.exp !== undefined ? token.exp * 1000 < Date.now() : true;
  } catch {
    return true;
  }
}

function obtenerRefreshToken() {
  let token = obtenerToken();
  return token.refresh_token;
}

function eliminarToken() {
  localStorage.removeItem("token");
}

const servicioToken = {
  guardarToken,
  obtenerToken,
  obtenerAccessToken,
  obtenerRefreshToken,
  eliminarToken,
  estaExpiradoElAccessToken,
};

export default servicioToken;
